import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { useModel } from "../../../models";
import { goPage } from "../../layout/pageDefinition";
import moment from "moment";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";


export default function () {
    const [
        { searchParam, documentStatistic, partDealList, partDealListSelectedRowKeys, searcnPage },
        { loadListDetail, setPartDealListSelectedRowKeys, exportPartDealList }
    ] = useModel("dinoutModel");

    const [{ }, { setSearchParam: setPurchasesSearchParam }] = useModel("purchasePo");
    const [{ }, { setSearchParam: setPurchasesRoSearchParam }] = useModel("purchaseRo");
    const [{ }, { setSearchParam: setSaleSoSearchParam }] = useModel("saleSo");
    const [{ }, { setSearchParam: setSaleRoSearchParam }] = useModel("saleRo");
    const columns = [
        {
            title: '序号',
            width: 50,
            render: (_, __, index) => <span>{index + 1}</span>,
        },

        {
            title: '日期',
            width: 160,
            dataIndex: 'deliveryDate',
            render: text => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""
        },
        {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            width: 200,
            dataIndex: 'materialName',
            align: 'left',
        },
        {
            title: '商品类型',
            width: 150,
            dataIndex: 'categoryName',
            align: 'left',
        },
        {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        },
        {
            title: '摘要',
            width: 120,
            dataIndex: 'diges',
        },
        {
            title: '入库',
            children: [

                {
                    title: '数量',
                    width: 80,
                    dataIndex: 'inNum',
                },
                {
                    title: '单价',
                    width: 80,
                    dataIndex: 'inPrice',
                },
                {
                    title: '金额',
                    width: 100,
                    dataIndex: 'inAmount',
                },
            ]
        },
        {
            title: '出库',
            children: [

                {
                    title: '数量',
                    width: 80,
                    dataIndex: 'outNum',
                },
                {
                    title: '单价',
                    width: 80,
                    dataIndex: 'outPrice',
                },
                {
                    title: '金额',
                    width: 100,
                    dataIndex: 'outAmount',
                },
            ]
        },

        {
            title: '期末数量',
            width: 100,
            dataIndex: 'endingBalance',
        },
        {
            title: '期末金额',
            width: 100,
            dataIndex: 'endingPrice',
        },
        {
            title: '业务单号',
            width: 180,
            dataIndex: 'oddNum',
            render: (value, row, index) => {
                return (
                    <a onClick={() => {
                        // 2-3
                        // 3-2
                        // debugger
                        switch (row.diges) {
                            case '采购':
                                setPurchasesSearchParam({ purchaseCode: row.oddNum })
                                goPage(history, "2-3");
                                break;
                            case '采购退货':
                                setPurchasesRoSearchParam({ returnCode: row.oddNum })
                                goPage(history, "2-4");
                                break;
                            case '销售':
                                setSaleSoSearchParam({ saleCode: row.oddNum })
                                goPage(history, "3-2");
                                break;
                            case '销售退货':
                                setSaleRoSearchParam({ returnCode: row.oddNum })
                                goPage(history, "3-3");
                                break;
                            default:
                                break;
                        }
                    }}>
                        {value}
                    </a>
                )
            }
        },
        {
            title: '对方单位',
            width: 250,
            dataIndex: 'company',
        },
    ];

    useEffect(() => {

        const { pageSize, pageNum } = searcnPage
        const { materialCode } = searchParam;
        let data = {
            pageSize,
            pageNum,
            materialCode, // "商品编号"
        }
        if (materialCode) {
            loadListDetail({ showMsg: true, data })
        }
    }, []);

    const history = useHistory();

    const onExport = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { inventoryListCode, orderStatus } = searchParam;
        let data = {
            startTime,
            endTime,
            inventoryListCode,
            orderStatus,
        }
        exportPartDealList({ showMsg: true, data });
    }

    const TableHeader = () => {

        const onExport = () => {
            // const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
            // const {purchaseCode, supplierId, orderStatus, invoiceType} = searchParam;
            // let data = {
            //     startTime,
            //     endTime,
            //     purchaseCode,
            //     supplierId,
            //     orderStatus,
            //     invoiceType
            // }
            // exportPo({showMsg: true, data})
        }

        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    {/* <YhAuth resCode={ResourceAuthEnum.STTICS_SPS_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth> */}
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span
                        className="margin-left-8">
                        入库数量合计：{!!documentStatistic ? documentStatistic.storageQuantityTotal : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        出库数量合计：{!!documentStatistic ? documentStatistic.deliveryQuantityTotal : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        出入库差异量：{!!documentStatistic ? documentStatistic.differenceTotal : 0}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={partDealList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (pageNum, pageSize) => {
                        // console.log(pageNum, pageSize)
                        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                        const { materialCode, category } = searchParam;
                        const data = {
                            materialCode, category,
                            startTime, endTime, pageNum, pageSize
                        }
                        loadListDetail({ showMsg: false, data });
                    },
                    total: searcnPage.total,
                    current: searcnPage.pageNum,
                }}
                // onRow={record => {
                //     return {

                //     };
                // }}
                // rowSelection={{
                //     type: "radio",
                //     onChange: (selectedRowKeys) => {
                //         setPartDealListSelectedRowKeys(selectedRowKeys)
                //     },
                //     selectedRowKeys: partDealListSelectedRowKeys
                // }}
                scroll={{ x: 'max-content', y: 580 }}
            />
        </>
    );
}